export default __webpack_public_path__ + "a4a6e2ce1bb2d5cc7a61ff302dbdfa0f.svg";